var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ELYXButton"},[(_vm.backdropEnabled)?_c('div',{staticClass:"ELYXButton__backdrop"}):_vm._e(),_c('button',{style:(_vm.getCustomStyles),on:{"click":_vm.callButton}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }